var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetFighter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "m21.078 10.822-.001-.004-.005-.017-.005-.019v-.002a.742.742 0 0 0-.067-.163.629.629 0 0 0-.126-.156l-.004-.004a.618.618 0 0 0-.136-.096L1.747.957a.552.552 0 0 0-.67.146.755.755 0 0 0-.177.494c0 .083.013.167.04.248L3.98 11 .94 20.155a.773.773 0 0 0 .138.74.55.55 0 0 0 .67.148l18.986-9.403a.616.616 0 0 0 .137-.097l.004-.004.026-.026a.685.685 0 0 0 .107-.146.757.757 0 0 0 .059-.147.634.634 0 0 0 .003-.013l.007-.024v-.004A.804.804 0 0 0 21.1 11a.81.81 0 0 0-.022-.178Zm-16.031.874h12.51L2.584 19.111l2.463-7.415Zm12.51-1.392H5.047L2.584 2.888l14.973 7.416Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetFighter);
export default __webpack_public_path__ + "static/media/jet-fighter.aeed0522e54fd6933909366e189dd786.svg";
export { ForwardRef as ReactComponent };